/**
 * -------------------------------------------------------------------------------------------
 * ADD CUSTOM JS HERE
 * -------------------------------------------------------------------------------------------
 */

// ----- Withdrawal form -----
(function () {
  if (customElements.get('inuvet-withdrawal-form')) return;

  const fields = [
    'name',
    'order_number',
    'email',
    'order_date',
    'items',
    'reason',
  ];

  class WithdrawalForm extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = this.querySelector('[data-withdrawal-form]');
      if (!this.form) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-withdrawal-config]').textContent);
      this.strings = this.config.strings;
      this.fieldsPanel = this.querySelector('[data-withdrawal-fields]');
      this.reviewPanel = this.querySelector('[data-withdrawal-review]');
      this.summary = this.querySelector('[data-withdrawal-summary]');
      this.error = this.querySelector('[data-withdrawal-error]');
      this.pending = this.querySelector('[data-withdrawal-pending]');
      this.success = this.querySelector('[data-withdrawal-success]');
      this.confirmButton = this.querySelector('[data-withdrawal-confirm]');
      this.editButton = this.querySelector('[data-withdrawal-edit]');
      this.intro = this.closest('.withdrawal-section')?.querySelector('[data-withdrawal-intro]');
      this.step = 'edit';
      this.submitting = false;

      this.form.addEventListener('input', (event) => {
        event.target.classList.toggle('is-filled', Boolean(event.target.value));
      });
      this.editButton.addEventListener('click', () => this.edit());
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (this.submitting || this.step === 'complete') return;
        if (this.step === 'review') {
          this.send();
        } else if (this.form.reportValidity()) {
          this.review();
        }
      });
      this.form.hidden = false;
    }

    readFields() {
      const data = new FormData(this.form);
      return Object.fromEntries(fields.map((key) => [key, data.get(key)]));
    }

    review() {
      this.reviewedValues = this.readFields();
      this.summary.replaceChildren();
      fields.forEach((key) => {
        const title = document.createElement('dt');
        const value = document.createElement('dd');
        title.textContent = this.strings[key];
        // User input stays plain text, including whitespace and incomplete descriptions.
        value.textContent = this.reviewedValues[key] || (key === 'items' ? this.strings.whole_order : this.strings.not_provided);
        this.summary.append(title, value);
      });
      this.error.hidden = true;
      this.fieldsPanel.hidden = true;
      this.reviewPanel.hidden = false;
      if (this.intro) this.intro.hidden = true;
      this.step = 'review';
      this.querySelector('[data-withdrawal-review-heading]').focus();
    }

    edit() {
      if (this.submitting) return;
      this.step = 'edit';
      this.reviewPanel.hidden = true;
      this.fieldsPanel.hidden = false;
      if (this.intro) this.intro.hidden = false;
      this.error.hidden = true;
      this.form.elements.namedItem('name').focus();
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
      this.error.focus();
    }

    async send() {
      // If autofill changed a field after review, show the updated values first.
      if (JSON.stringify(this.readFields()) !== JSON.stringify(this.reviewedValues)) {
        this.edit();
        if (this.form.reportValidity()) this.review();
        return;
      }
      if (!this.config.endpoint) {
        this.showError(this.strings.unavailable);
        return;
      }

      if (!this.submissionId) this.submissionId = crypto.randomUUID();
      const payload = {
        source: 'withdrawal_form',
        shop_domain: this.config.shopDomain,
        locale: this.config.locale,
        submission_id: this.submissionId,
        internal_recipients: this.config.internalRecipients || '',
        withdrawal: { ...this.reviewedValues },
      };

      this.submitting = true;
      this.confirmButton.disabled = true;
      this.editButton.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.pending.hidden = false;
      this.error.hidden = true;

      try {
        const response = await fetch(this.config.endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Shop-Domain': this.config.shopDomain,
          },
          body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error('Withdrawal request failed');
        const result = await response.json();
        if (result.success !== true) throw new Error('Withdrawal not acknowledged');
        this.step = 'complete';
        this.form.hidden = true;
        if (this.intro) this.intro.hidden = true;
        this.success.hidden = false;
        this.success.focus();
      } catch {
        this.showError(this.strings.submission_error);
      } finally {
        this.submitting = false;
        this.confirmButton.disabled = false;
        this.editButton.disabled = false;
        this.form.removeAttribute('aria-busy');
        this.pending.hidden = true;
      }
    }
  }

  customElements.define('inuvet-withdrawal-form', WithdrawalForm);
})();
// ----- End withdrawal form -----


(function () {
  var SHOLESFAP_BASE =
    (window.inuvetShop && window.inuvetShop.sholesfapBase) ||
    "https://sholesfap-a06968366f91.herokuapp.com";

  function recordFunnelEvent(endpoint, extras) {
    if (!window.inuvetShop || !window.inuvetShop.customerId) return;

    var body = {
      shopify_id: String(window.inuvetShop.customerId),
      shop_domain: window.inuvetShop.domain,
      country: (window.inuvetShop.country || "").toString().toUpperCase(),
      opened_at: new Date().toISOString(),
    };
    if (extras && typeof extras === "object") {
      Object.keys(extras).forEach(function (key) {
        if (extras[key] != null && extras[key] !== "") body[key] = extras[key];
      });
    }

    fetch(SHOLESFAP_BASE + "/webhooks/" + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "X-Shopify-Shop-Domain": window.inuvetShop.domain,
      },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(function (error) {
      console.warn("[inuvet] Could not record funnel event", endpoint, error);
    });
  }

  window.inuvetRecordFunnelEvent = recordFunnelEvent;

  function cartAddExtras(event) {
    var variant = event && event.detail && event.detail.variant;
    var variantId = variant && variant.id;
    if (variantId == null) return {};

    var productInfo = window.inuvetProduct || {};
    var variantSalesforceIds = productInfo.variantSalesforceIds || {};
    var salesforceProductId = variantSalesforceIds[variantId];
    if (salesforceProductId && typeof salesforceProductId === "object") {
      salesforceProductId = salesforceProductId.value;
    }
    if (salesforceProductId == null || salesforceProductId === "") return {};
    return { salesforce_product_id: String(salesforceProductId) };
  }

  function cartJsUrl() {
    var routes = window.themeVariables && window.themeVariables.routes;
    var cartUrl = (routes && routes.cartUrl) || "/cart";
    return cartUrl + ".js";
  }

  function snapshotCartLines(cart) {
    var items = (cart && cart.items) || [];
    return items
      .map(function (item) {
        return {
          variant_id: String(item.variant_id || item.id || ""),
          quantity: Number(item.quantity) || 0,
        };
      })
      .filter(function (item) {
        return item.variant_id !== "" && item.quantity > 0;
      });
  }

  function recordCartSnapshot() {
    fetch(cartJsUrl(), { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("cart.js " + response.status);
        return response.json();
      })
      .then(function (cart) {
        var items = snapshotCartLines(cart);
        if (!items.length) return;
        recordFunnelEvent("receive_cart_snapshot", { items: items });
      })
      .catch(function (error) {
        console.warn("[inuvet] Could not snapshot cart", error);
      });
  }

  document.addEventListener("variant:added", function (event) {
    var extras = {};
    try {
      extras = cartAddExtras(event);
    } catch (error) {
      console.warn("[inuvet] Could not resolve cart add product", error);
    }
    recordFunnelEvent("receive_cart_add", extras);
    try {
      recordCartSnapshot();
    } catch (error) {
      console.warn("[inuvet] Could not snapshot cart", error);
    }
  });
})();

(function () {
  if (window.location.pathname.indexOf("/products/") === -1) return;
  if (!window.inuvetShop || !window.inuvetShop.customerId) return;
  if (typeof window.inuvetRecordFunnelEvent !== "function") return;

  var THRESHOLDS = [
    { seconds: 60, endpoint: "receive_product_dwell_60s", key: "60s" },
    { seconds: 90, endpoint: "receive_product_dwell_90s", key: "90s" },
    { seconds: 120, endpoint: "receive_product_dwell_120s", key: "120s" },
  ];
  var storagePrefix = "inuvet_product_dwell_" + window.location.pathname + "_";
  var productInfo = window.inuvetProduct || {};
  var variantSalesforceIds = productInfo.variantSalesforceIds || {};
  var currentVariantId = productInfo.selectedVariantId;
  var engagedMs = 0;
  var lastTick = null;
  var fired = {};

  document.addEventListener("variant:changed", function (event) {
    if (event.detail && event.detail.variant && event.detail.variant.id != null) {
      currentVariantId = event.detail.variant.id;
    }
  });

  function dwellExtras() {
    var salesforceProductId = variantSalesforceIds[currentVariantId];
    if (salesforceProductId && typeof salesforceProductId === "object") {
      salesforceProductId = salesforceProductId.value;
    }
    if (salesforceProductId == null || salesforceProductId === "") return {};
    return { salesforce_product_id: String(salesforceProductId) };
  }

  THRESHOLDS.forEach(function (threshold) {
    try {
      if (sessionStorage.getItem(storagePrefix + threshold.key)) {
        fired[threshold.key] = true;
      }
    } catch (error) {
      // sessionStorage may be unavailable
    }
  });

  function tick() {
    if (document.visibilityState !== "visible") {
      lastTick = null;
      return;
    }

    var now = Date.now();
    if (lastTick != null) {
      engagedMs += now - lastTick;
    }
    lastTick = now;

    var engagedSec = engagedMs / 1000;
    THRESHOLDS.forEach(function (threshold) {
      if (fired[threshold.key] || engagedSec < threshold.seconds) return;

      fired[threshold.key] = true;
      try {
        sessionStorage.setItem(storagePrefix + threshold.key, "1");
      } catch (error) {
        // sessionStorage may be unavailable
      }
      window.inuvetRecordFunnelEvent(threshold.endpoint, dwellExtras());
    });
  }

  setInterval(tick, 1000);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      lastTick = Date.now();
    } else {
      lastTick = null;
    }
  });
  if (document.visibilityState === "visible") {
    lastTick = Date.now();
  }
})();

(function () {
  if (window.location.pathname.indexOf("/products/") === -1) {
    return;
  }

  function formatProductPageReviewsIoRating() {
    document
      .querySelectorAll(".product__info reviewsio-product-ratings .ruk_rating_snippet")
      .forEach(function (snippet) {
        var countElements = snippet.querySelectorAll(".ruk-rating-snippet-count");

        if (countElements.length > 1) {
          countElements[0].classList.add("reviewsio-product-rating__review-count");
        }

        countElements.forEach(function (countElement) {
          var text = countElement.textContent.trim();
          var ratingMatch = text.match(/^([0-9]+(?:[.,][0-9]+)?)\s*\/\s*[0-9]+(?:[.,][0-9]+)?$/);

          if (ratingMatch && countElement.textContent !== ratingMatch[1]) {
            countElement.textContent = ratingMatch[1];
          }
        });
      });
  }

  function scheduleProductPageReviewsIoRatingFormat() {
    formatProductPageReviewsIoRating();
    window.setTimeout(formatProductPageReviewsIoRating, 300);
    window.setTimeout(formatProductPageReviewsIoRating, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleProductPageReviewsIoRatingFormat);
  } else {
    scheduleProductPageReviewsIoRatingFormat();
  }

  if (window.MutationObserver) {
    var reviewsIoProductRatingObserver = new MutationObserver(formatProductPageReviewsIoRating);

    reviewsIoProductRatingObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
})();

// Create a URL object from the current location
const currentUrl = new URL(window.location.href);

// Check if the query param "mc" is present and equals "open"
if (currentUrl.searchParams.get("mc") === "open") {
  const miniCart = document.getElementById("mini-cart");
  if (miniCart) {
    miniCart.setAttribute("open", "");
  }
}

const currentPath = window.location.pathname;

// Regex for the first redirection case (agnostic of the domain)
const idRegex = /^\/id\/(\d+)/;
if (idRegex.test(currentPath)) {
  const idMatch = currentPath.match(idRegex);
  window.location.href = `https://archive.inuvet.com/id/${idMatch[1]}`;
}

// Regex for the second redirection case (agnostic of the domain)
const productRegex = /^\/([a-z]{2}-[a-z]{2})\/produkte\/(.+)/;
if (productRegex.test(currentPath)) {
  const productMatch = currentPath.match(productRegex);
  const locale = productMatch[1];
  const productName = productMatch[2];

  // Check if the locale matches the provided regex pattern
  const localeRegex =
    /^(de|en|fr|es|it|nl|pl|ja|zh)-?(de|at|ch|fr|ie|gb|be|nl|lu|it|es|pl|jp|cn|tw)?$/;
  if (localeRegex.test(locale)) {
    window.location.href = `https://inuvet.com/products/${productName}`;
  }
}

/**
 * -------------------------------------------------------------------------------------------
 * TOGGLE PASSWORD
 * -------------------------------------------------------------------------------------------
 */

document.addEventListener("DOMContentLoaded", () => {
  const passwordField = document.getElementById("customer[password]");
  const eyeOpen = document.getElementById("eye-open");
  const eyeClosed = document.getElementById("eye-closed");

  if (passwordField && eyeOpen && eyeClosed) {
    const togglePassword = () => {
      if (passwordField.type === "password") {
        passwordField.type = "text";
        eyeOpen.style.display = "none";
        eyeClosed.style.display = "inline";
      } else {
        passwordField.type = "password";
        eyeOpen.style.display = "inline";
        eyeClosed.style.display = "none";
      }
    };

    // Attach the togglePassword function to the click event of the password toggle
    document
      .querySelector(".password-toggle")
      .addEventListener("click", togglePassword);

    // Initial state: show eye open icon, hide eye closed icon
    eyeOpen.style.display = "inline";
    eyeClosed.style.display = "none";
  }
});

/**
 * -------------------------------------------------------------------------------------------
 * GOOGLE ANALYTICS
 * -------------------------------------------------------------------------------------------
 */

// GTM + Consent Mode + Banner & Modal Logic
(function () {
  // ----- Helpers -----
  const getCookieValue = (name) => {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)"),
    );
    return match ? decodeURIComponent(match[2]) : null;
  };

  const setConsentCookie = (analytics, marketing, performance) => {
    const consent = {
      con: {
        CMP: {
          a: analytics ? "1" : "",
          m: marketing ? "1" : "",
          p: performance ? "1" : "",
        },
      },
    };

    // Ask for consent again after 6 months.
    const expires = new Date();
    expires.setMonth(expires.getMonth() + 6);

    document.cookie = `custom_tracking_consent=${encodeURIComponent(
      JSON.stringify(consent),
    )}; path=/; SameSite=Lax; expires=${expires.toUTCString()}`;
    // document.cookie = `custom_tracking_consent=${encodeURIComponent(JSON.stringify(consent))}; path=/; SameSite=Lax`;
  };

  const getTrackingConsent = () => {
    try {
      const consentCookie = getCookieValue("custom_tracking_consent");
      const consent = JSON.parse(consentCookie).con.CMP;

      return {
        analytics: consent.a === "1",
        marketing: consent.m === "1",
        performance: consent.p === "1",
        cookie_set: true,
      };
    } catch {
      return {
        analytics: false,
        marketing: false,
        performance: false,
        cookie_set: false,
      };
    }
  };

  // ----- Campaign attribution (analytics consent required) -----
  const utmStorageKey = "utm_params";
  const utmKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
  ];
  // Attribution window; sholesfap applies the same limit (UTM_ATTRIBUTION_DAYS).
  const utmMaxAgeMs = 7 * 24 * 60 * 60 * 1000;
  let utmCaptureComplete = false;

  const removeStoredUtms = () => {
    try {
      localStorage.removeItem(utmStorageKey);
    } catch {}
  };

  // Entries saved before captured_at existed have no timestamp and stay valid.
  const utmExpired = (stored) => {
    if (!stored || typeof stored.captured_at !== "string") return false;
    const capturedAt = Date.parse(stored.captured_at);
    return isNaN(capturedAt) || Date.now() - capturedAt > utmMaxAgeMs;
  };

  const readStoredUtms = () => {
    const stored = JSON.parse(localStorage.getItem(utmStorageKey));
    if (utmExpired(stored)) {
      removeStoredUtms();
      return null;
    }
    return stored;
  };

  // Saves the campaign on the logged-in customer so another device can use it for the order.
  const syncUtmToCustomer = () => {
    const shop = window.inuvetShop;
    if (!shop || !shop.customerId || typeof fetch !== "function") return;
    if (!getTrackingConsent().analytics) return;
    try {
      const stored = readStoredUtms();
      const params = filterUtmParams(stored);
      const customerId = String(shop.customerId);
      if (!Object.keys(params).length || !stored.captured_at) return;
      if (stored.synced_customer_id === customerId) return;

      fetch((shop.sholesfapBase || "https://sholesfap-a06968366f91.herokuapp.com") + "/webhooks/receive_utm_touch", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "X-Shopify-Shop-Domain": shop.domain,
        },
        body: JSON.stringify(Object.assign({ customerId: customerId, captured_at: stored.captured_at }, params)),
        keepalive: true,
      }).then((response) => {
        if (!response.ok) return;
        // Only mark the campaign that was sent; a newer one may have replaced it meanwhile.
        const current = JSON.parse(localStorage.getItem(utmStorageKey));
        if (current && current.captured_at === stored.captured_at) {
          current.synced_customer_id = customerId;
          localStorage.setItem(utmStorageKey, JSON.stringify(current));
        }
      }).catch((error) => {
        console.warn("[inuvet] Could not save UTMs on customer", error);
      });
    } catch {}
  };

  const filterUtmParams = (values) => {
    const params = {};
    if (!values || typeof values !== "object" || Array.isArray(values)) return params;
    utmKeys.forEach((key) => {
      if (typeof values[key] === "string" && values[key].trim()) {
        params[key] = values[key].trim();
      }
    });
    return params;
  };

  const syncUtmConsent = () => {
    if (!getTrackingConsent().analytics) {
      removeStoredUtms();
      return;
    }
    if (utmCaptureComplete) return;

    const query = new URLSearchParams(window.location.search);
    const values = {};
    utmKeys.forEach((key) => { values[key] = query.get(key); });
    const params = filterUtmParams(values);
    try {
      // Replace the whole campaign to avoid mixing fields from separate visits.
      if (Object.keys(params).length) {
        params.captured_at = new Date().toISOString();
        localStorage.setItem(utmStorageKey, JSON.stringify(params));
      }
      utmCaptureComplete = true;
    } catch {}
    syncUtmToCustomer();
  };

  window.inuvetUtm = {
    hasConsent() {
      return getTrackingConsent().analytics;
    },
    read() {
      // Recheck the cookie at submission, including expiry or changes in another tab.
      if (!getTrackingConsent().analytics) {
        removeStoredUtms();
        return {};
      }
      try {
        return filterUtmParams(readStoredUtms());
      } catch {
        removeStoredUtms();
        return {};
      }
    },
    capturedAt() {
      if (!getTrackingConsent().analytics) return null;
      try {
        const stored = readStoredUtms();
        return stored && typeof stored.captured_at === "string" ? stored.captured_at : null;
      } catch {
        return null;
      }
    },
    clear() {
      // Consent updates must not recapture this page's campaign after sending it.
      utmCaptureComplete = true;
      removeStoredUtms();
    },
  };
  syncUtmConsent();

  // ----- Ad click IDs for Meta Conversions API / Google Ads (marketing consent required) -----
  const adClickStorageKey = "ad_click_ids";
  // Meta and Google apply their own attribution windows; this only limits how long we keep the IDs.
  const adClickMaxAgeMs = 90 * 24 * 60 * 60 * 1000;

  const removeStoredAdClicks = () => {
    try {
      localStorage.removeItem(adClickStorageKey);
    } catch {}
  };

  const readStoredAdClicks = () => {
    const stored = JSON.parse(localStorage.getItem(adClickStorageKey));
    if (!stored || typeof stored !== "object" || Array.isArray(stored)) return {};
    const ids = {};
    ["fbc", "gclid"].forEach((key) => {
      const capturedAt = Date.parse(stored[key + "_at"]);
      if (typeof stored[key] === "string" && stored[key] && !isNaN(capturedAt) && Date.now() - capturedAt <= adClickMaxAgeMs) {
        ids[key] = stored[key];
        ids[key + "_at"] = stored[key + "_at"];
      }
    });
    return ids;
  };

  const syncAdClickConsent = () => {
    if (!getTrackingConsent().marketing) {
      removeStoredAdClicks();
      return;
    }
    try {
      const query = new URLSearchParams(window.location.search);
      const ids = readStoredAdClicks();
      const now = new Date();
      const fbclid = (query.get("fbclid") || "").trim();
      const gclid = (query.get("gclid") || "").trim();
      // Same format as Meta's _fbc cookie: fb.<subdomain index>.<click time ms>.<fbclid>
      if (fbclid && !(ids.fbc && ids.fbc.endsWith("." + fbclid))) {
        ids.fbc = "fb.1." + now.getTime() + "." + fbclid;
        ids.fbc_at = now.toISOString();
      }
      if (gclid && ids.gclid !== gclid) {
        ids.gclid = gclid;
        ids.gclid_at = now.toISOString();
      }
      if (Object.keys(ids).length) localStorage.setItem(adClickStorageKey, JSON.stringify(ids));
    } catch {}
  };

  window.inuvetAdClicks = {
    hasConsent() {
      return getTrackingConsent().marketing;
    },
    read() {
      if (!getTrackingConsent().marketing) {
        removeStoredAdClicks();
        return {};
      }
      const ids = {};
      try {
        const stored = readStoredAdClicks();
        if (stored.fbc) ids.fbc = stored.fbc;
        if (stored.gclid) ids.gclid = stored.gclid;
      } catch {
        removeStoredAdClicks();
      }
      // Cookies set by the Meta pixel itself win over our copy.
      const fbcCookie = getCookieValue("_fbc");
      const fbpCookie = getCookieValue("_fbp");
      if (fbcCookie) ids.fbc = fbcCookie;
      if (fbpCookie) ids.fbp = fbpCookie;
      return ids;
    },
  };
  syncAdClickConsent();

  // ----- Google Tag Consent Mode Setup -----
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }

  const updateConsentInGTM = (consent) => {
    syncUtmConsent();
    syncAdClickConsent();
    const consentMap = { true: "granted", false: "denied" };

    gtag("consent", "update", {
      analytics_storage: consentMap[consent.analytics],
      ad_storage: consentMap[consent.marketing],
      ad_user_data: consentMap[consent.marketing],
      ad_personalization: consentMap[consent.marketing],
    });

    localStorage.setItem("analytics_storage", consentMap[consent.analytics]);
    localStorage.setItem("ad_storage", consentMap[consent.marketing]);

    window.dataLayer.push({
      event: "consentBannerUpdate",
      consentStatistics: consent.analytics,
      consentMarketing: consent.marketing,
    });
  };

  // ----- Initial Consent on Load -----
  const defaultConsent = {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  };

  const savedAnalytics = localStorage.getItem("analytics_storage");
  const savedMarketing = localStorage.getItem("ad_storage");

  if (savedAnalytics) defaultConsent.analytics_storage = savedAnalytics;
  if (savedMarketing) {
    defaultConsent.ad_storage = savedMarketing;
    defaultConsent.ad_user_data = savedMarketing;
    defaultConsent.ad_personalization = savedMarketing;
  }

  gtag("consent", "default", defaultConsent);

  const currentConsent = getTrackingConsent();

  if (currentConsent.cookie_set) {
    // Send consent only if previously stored
    updateConsentInGTM(currentConsent);
  }

  // if (savedAnalytics && savedMarketing) {
  //   updateConsentInGTM(getTrackingConsent(), false);
  // }

  // GTM Initialization
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-TZKFMP96");

  // ----- Cookie Banner Behavior -----
  const banner = document.getElementById("cookie-banner");
  const modal = document.getElementById("cookie-modal");
  const isThemeEditor =
    Boolean(window.Shopify && window.Shopify.designMode) ||
    banner?.dataset.designMode === "true" ||
    modal?.dataset.designMode === "true";
  const setConsentUiLock = (isLocked) => {
    document.body.classList.toggle("cookie-consent-open", isLocked);
  };

  const showBanner = () => {
    if (banner) {
      banner.style.display = "flex";
      banner.classList.add("show");
      banner.classList.remove("hide");
      setConsentUiLock(true);
    }
  };

  const hideBanner = () => {
    if (banner) {
      banner.style.display = "none";
      banner.classList.add("hide");
      banner.classList.remove("show");
      setConsentUiLock(false);
    }
  };

  const completeCookiePopup = () => {
    window.InuvetPopupCoordinator?.complete("cookie");
  };

  const showModal = () => {
    if (modal) {
      modal.style.display = "block";
    }
  };
  const hideModal = () => {
    if (modal) {
      modal.style.display = "none";
    }
  };

  const acceptAllBtn = document.getElementById("banner-accept-all");
  const customSettingsBtn = document.getElementById("banner-customize");
  const modalSaveBtn = document.getElementById("modal-save-preferences");
  const modalAcceptBtn = document.getElementById("modal-accept-all");
  const modalRejectBtn = document.getElementById("modal-reject-all");
  const modalCloseBtn = document.getElementById("close-modal");

  const checkAnalytics = document.getElementById("modal-data-checkbox");
  const checkMarketing = document.getElementById("modal-marketing-checkbox");
  const checkPerformance = document.getElementById(
    "modal-customization-checkbox",
  );
  const cookieLinkFooter = document.getElementById("cookie-link");

  if (isThemeEditor) {
    hideBanner();
    hideModal();
    setConsentUiLock(false);
    return;
  }

  if (window.InuvetPopupCoordinator) {
    window.InuvetPopupCoordinator.register("cookie", {
      eligible: () => !getTrackingConsent().cookie_set,
      isDismissed: () => getTrackingConsent().cookie_set,
      delaySeconds: 0,
      show: showBanner,
    });
  }

  if (acceptAllBtn) {
    acceptAllBtn.addEventListener("click", () => {
      setConsentCookie(true, true, true);
      updateConsentInGTM({
        analytics: true,
        marketing: true,
        performance: true,
      });
      hideBanner();
      completeCookiePopup();
    });
  }

  if (customSettingsBtn) {
    customSettingsBtn.addEventListener("click", () => {
      hideBanner();
      showModal();
    });
  }

  if (modalAcceptBtn) {
    modalAcceptBtn.addEventListener("click", () => {
      setConsentCookie(true, true, true);
      updateConsentInGTM({
        analytics: true,
        marketing: true,
        performance: true,
      });
      hideModal();
      completeCookiePopup();
    });
  }

  if (modalRejectBtn) {
    modalRejectBtn.addEventListener("click", () => {
      setConsentCookie(false, false, false);
      updateConsentInGTM({
        analytics: false,
        marketing: false,
        performance: false,
      });
      hideModal();
      hideBanner();
      completeCookiePopup();
    });
  }

  if (modalSaveBtn) {
    modalSaveBtn.addEventListener("click", () => {
      const analytics = checkAnalytics?.checked;
      const marketing = checkMarketing?.checked;
      const performance = checkPerformance?.checked;
      setConsentCookie(analytics, marketing, performance);
      updateConsentInGTM({ analytics, marketing, performance });
      hideModal();
      completeCookiePopup();
    });
  }

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener("click", () => {
      hideModal();
      showBanner();
    });
  }

  if (cookieLinkFooter) {
    cookieLinkFooter.addEventListener("click", () => {
      showBanner();
    });
  }

  // ----- Shopify Purchase Event Injection -----
  const shopifyOrderString = localStorage.getItem("shopifyOrder");
  if (shopifyOrderString) {
    const shopifyOrder = JSON.parse(shopifyOrderString)["order"];
    const purchase = {
      event: "purchase",
      ecommerce: {
        transaction_id: shopifyOrder["name"],
        value: shopifyOrder["total_price"],
        currency: shopifyOrder["currency"],
        items: [],
        shipping: 0.0,
      },
    };
    if (shopifyOrder["shipping_lines"]?.[0]) {
      purchase.ecommerce.shipping = shopifyOrder.shipping_lines[0].price;
      purchase.ecommerce.value -= purchase.ecommerce.shipping;
    }
    shopifyOrder.line_items.forEach((lineItem) => {
      purchase.ecommerce.items.push({
        item_id: lineItem.variant_id,
        quantity: lineItem.quantity,
        price: lineItem.price,
        item_name: lineItem.name,
      });
    });
    // For Google Ads Enhanced Conversions (GTM "User-provided data" variable reads user_data).
    const purchaseUserData = JSON.parse(shopifyOrderString)["user_data"];
    if (purchaseUserData && getTrackingConsent().marketing) {
      purchase.user_data = purchaseUserData;
    }

    window.dataLayer.push(purchase);
    localStorage.removeItem("shopifyOrder");
    window.dataLayer.push({ event: "gtm.load" });

    // Clear abandoned cart marker
    localStorage.removeItem("cartStarted");
  }

  // ----- Product view tracking -----
  if (window.template?.includes("product") && window.productJSON) {
    function pushProductView() {
      window.dataLayer.push({
        event: "product_view",
        ecommerce: {
          currency: window.shopCurrency,
          items: [
            {
              item_id: window.productJSON.id,
              item_name: window.productJSON.title,
              price: (window.productJSON.price / 100).toFixed(2), // convert cents to currency
            },
          ],
        },
        user: window.customerData || { id: null },
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", pushProductView);
    } else {
      pushProductView();
    }
  }

  (function () {
    function handleCartEvent() {
      if (!localStorage.getItem("cartStarted")) {
        localStorage.setItem("cartStarted", Date.now());
      }
    }

    document.addEventListener("cart:updated", (e) => {
      handleCartEvent();
    });
  })();

  // Shopify Login Event
  (function () {
    window.dataLayer = window.dataLayer || [];

    const STORAGE_KEY_ATTEMPT = "shopify_login_attempt_ts";
    const STORAGE_KEY_FIRED = "shopify_login_success_fired";
    const STORAGE_KEY_RETURN_TO = "shopify_login_return_to";
    const ATTEMPT_TTL_MS = 2 * 60 * 1000; // 2 minutes

    function now() {
      return Date.now ? Date.now() : new Date().getTime();
    }

    function safeGet(key) {
      try {
        return sessionStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function safeSet(key, val) {
      try {
        sessionStorage.setItem(key, val);
      } catch (e) {}
    }
    function safeRemove(key) {
      try {
        sessionStorage.removeItem(key);
      } catch (e) {}
    }

    function getCustomerId() {
      if (!window.customerData) return null;
      return window.customerData.id || null;
    }

    function isAccountLoginUrl(url) {
      try {
        const parsed = new URL(url, window.location.origin);
        return parsed.origin === window.location.origin && /(^|\/)account\/login\/?$/.test(parsed.pathname);
      } catch (e) {
        return false;
      }
    }

    function isValidReturnPath(value) {
      if (!value || value.charAt(0) !== "/" || value.indexOf("//") === 0) return false;
      return !/(^|\/)account(\/|$)/.test(value);
    }

    function getCurrentReturnPath() {
      const path = window.location.pathname + window.location.search + window.location.hash;
      return isValidReturnPath(path) ? path : null;
    }

    function getStoredReturnPath() {
      const path = safeGet(STORAGE_KEY_RETURN_TO);
      return isValidReturnPath(path) ? path : null;
    }

    function rememberReferrerReturnPath() {
      if (getStoredReturnPath() || !isAccountLoginUrl(window.location.href) || !document.referrer) return;

      try {
        const referrer = new URL(document.referrer);
        if (referrer.origin !== window.location.origin) return;

        const returnPath = referrer.pathname + referrer.search + referrer.hash;
        if (isValidReturnPath(returnPath)) safeSet(STORAGE_KEY_RETURN_TO, returnPath);
      } catch (e) {}
    }

    function setLoginFormReturnTo(form) {
      const returnPath = getStoredReturnPath();
      if (!returnPath) return;

      let input = form.querySelector('input[name="return_to"]');
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "return_to";
        form.appendChild(input);
      }

      input.value = returnPath;
    }

    document.addEventListener(
      "click",
      function (e) {
        const link = e.target.closest && e.target.closest('a[href]');
        if (!link || !isAccountLoginUrl(link.href)) return;

        const returnPath = getCurrentReturnPath();
        if (returnPath) safeSet(STORAGE_KEY_RETURN_TO, returnPath);
      },
      true,
    );

    rememberReferrerReturnPath();

    document.addEventListener(
      "submit",
      function (e) {
        const form = e.target;
        if (!form || form.tagName !== "FORM") return;

        const action = (form.getAttribute("action") || "").toLowerCase();
        const isLoginForm =
          action.indexOf("/account/login") !== -1 ||
          form.id === "customer_login" ||
          form.getAttribute("name") === "customer_login";

        if (!isLoginForm) return;

        setLoginFormReturnTo(form);
        safeSet(STORAGE_KEY_ATTEMPT, String(now()));
        safeRemove(STORAGE_KEY_FIRED);
      },
      true,
    );

    (function fireLoginSuccessIfEligible() {
      const customerId = getCustomerId();
      if (!customerId) return;

      if (safeGet(STORAGE_KEY_FIRED) === "1") return;

      let attemptTs = parseInt(safeGet(STORAGE_KEY_ATTEMPT) || "0", 10);
      if (!attemptTs) return;

      if (now() - attemptTs > ATTEMPT_TTL_MS) {
        safeRemove(STORAGE_KEY_ATTEMPT);
        return;
      }

      safeRemove(STORAGE_KEY_ATTEMPT);
      safeRemove(STORAGE_KEY_RETURN_TO);
      safeSet(STORAGE_KEY_FIRED, "1");

      window.dataLayer.push({
        event: "shopify_login",
        login_status: "success",
        customer_logged_in: true,
        customer_id: String(customerId),
      });
    })();
  })();

  // Multi-Stage Abandoned Cart Logic
  const ABANDONED_THRESHOLDS = [180, 1440, 2880, 4320, 7200]; // minutes: 3h, 24h, 48h, 72h, 120h

  // Ensure the tracker object exists
  function initAbandonedStages() {
    if (!localStorage.getItem("abandonedChecks")) {
      const stageFlags = {};
      ABANDONED_THRESHOLDS.forEach((min) => (stageFlags[min] = false));
      localStorage.setItem("abandonedChecks", JSON.stringify(stageFlags));
    }
  }

  // Universal abandoned cart firing logic
  async function triggerAbandonedEvent(label) {
    const cart = await fetchCartData();
    if (!cart || cart.item_count === 0) return;

    const cartTotal = cart.total_price / 100;
    const shopCurrency = cart.currency;
    const cartItems = cart.items.map((item) => ({
      item_id: item.variant_id,
      item_name: item.title,
      price: item.price / 100,
      quantity: item.quantity,
    }));

    window.dataLayer.push({
      event: "view_cart",
      ecommerce: {
        value: cartTotal,
        currency: shopCurrency,
        items: cartItems,
      },
      user: window.customerData || { id: null },
      purpose: `Abandoned cart - ${label}`,
    });
  }

  function checkMultiStageAbandonment() {
    const startedAt = localStorage.getItem("cartStarted");
    if (!startedAt) return;

    initAbandonedStages();
    const stageFlags = JSON.parse(localStorage.getItem("abandonedChecks"));

    const now = Date.now();
    const minutesSince = (now - parseInt(startedAt, 10)) / 1000 / 60;

    ABANDONED_THRESHOLDS.forEach((threshold) => {
      if (!stageFlags[threshold] && minutesSince >= threshold) {
        // Create label
        let label = "";
        if (threshold === 180) label = "3h";
        else if (threshold === 1440) label = "24h";
        else if (threshold === 2880) label = "48h";
        else if (threshold === 4320) label = "72h";
        else if (threshold === 7200) label = "120h";

        // Fire abandoned cart event
        triggerAbandonedEvent(label);

        // Mark this threshold as used
        stageFlags[threshold] = true;
        localStorage.setItem("abandonedChecks", JSON.stringify(stageFlags));
      }
    });
  }

  // Run on every page load
  document.addEventListener("DOMContentLoaded", checkMultiStageAbandonment);

  // Background timer checks (every 5 minutes)
  setInterval(checkMultiStageAbandonment, 5 * 60 * 1000);
})();

/**
 * -------------------------------------------------------------------------------------------
 * MAIN COLLECTION FILTER
 * -------------------------------------------------------------------------------------------
 */

document.addEventListener("DOMContentLoaded", function () {
  const filterButtons = document.querySelectorAll(".main-collection-filter");
  const mainProductContainer = document.getElementById(
    "product-list-container",
  );
  const archiveProductContainer = document.getElementById(
    "archive-product-list-container",
  );
  if (mainProductContainer) {
    const currentCollection = (
      mainProductContainer.dataset.currentCollection || ""
    )
      .trim()
      .toLowerCase();
    const getCollectionHandles = (handles) =>
      (handles || "")
        .split(",")
        .map((handle) => handle.trim().toLowerCase())
        .filter(Boolean);
    const scopeCollections = getCollectionHandles(
      mainProductContainer.dataset.scopeCollections,
    );
    const products = Array.from(
      mainProductContainer.querySelectorAll(".product-item-container"),
    );
    const intermediaryBlock = mainProductContainer.querySelector(
      ".image-with-text-embed",
    );
    const intermediaryInsertAfter = Number.parseInt(
      mainProductContainer.dataset.iwtInsertAfter,
      10,
    );
    const archiveFilter = "produktarchiv";
    const getButtonCollections = (button) =>
      getCollectionHandles(button.dataset.collections);

    filterButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const selectedFilter = (this.dataset.filter || "").trim().toLowerCase();
        let selectedCollections = getButtonCollections(this);

        if (scopeCollections.length > 0) {
          selectedCollections =
            selectedFilter === "all_products"
              ? scopeCollections
              : selectedCollections.filter((handle) =>
                  scopeCollections.includes(handle),
                );
        }

        filterButtons.forEach((btn) => btn.classList.remove("active"));
        this.classList.add("active");

        if (selectedFilter === archiveFilter && archiveProductContainer) {
          mainProductContainer.style.display = "none";
          archiveProductContainer.style.display = "block";
          return;
        }

        mainProductContainer.style.display = "block";
        if (archiveProductContainer) {
          archiveProductContainer.style.display = "none";
        }

        filterProducts(selectedFilter, selectedCollections);
      });
    });

    function filterProducts(filter, selectedCollections = []) {
      products.forEach((product) => {
        const normalizedFilter = (filter || "").trim().toLowerCase();
        const productCollections = (product.dataset.collections || "")
          .split(",")
          .map((handle) => handle.trim().toLowerCase())
          .filter(Boolean);
        const belongsToSelectedCollection = selectedCollections.some((handle) =>
          productCollections.includes(handle),
        );
        const showsEntireListing =
          normalizedFilter === "all_products" &&
          selectedCollections.length === 0;

        if (showsEntireListing || belongsToSelectedCollection) {
          product.style.display = "block";
        } else {
          product.style.display = "none";
        }
      });

      updateIntermediaryBlock();
    }

    function updateIntermediaryBlock() {
      if (!intermediaryBlock) {
        return;
      }

      const visibleProducts = products.filter(
        (product) => product.style.display !== "none",
      );
      const hasEnoughVisibleProducts =
        Number.isInteger(intermediaryInsertAfter) &&
        intermediaryInsertAfter > 0 &&
        visibleProducts.length >= intermediaryInsertAfter;

      intermediaryBlock.hidden = !hasEnoughVisibleProducts;

      if (hasEnoughVisibleProducts) {
        visibleProducts[intermediaryInsertAfter - 1].insertAdjacentElement(
          "afterend",
          intermediaryBlock,
        );
      }
    }

    // Start with the filter that contains the current collection.
    if (archiveProductContainer) {
      archiveProductContainer.style.display = "none";
    }

    const initialFilterButton =
      (currentCollection.startsWith("heimtiere-") &&
        Array.from(filterButtons).find(
          (button) => button.dataset.filter === "small_pets",
        )) ||
      Array.from(filterButtons).find((button) => {
        const buttonFilter = (button.dataset.filter || "").trim().toLowerCase();
        return (
          buttonFilter === currentCollection ||
          getButtonCollections(button).includes(currentCollection)
        );
      }) ||
      Array.from(filterButtons).find(
        (button) => button.dataset.filter === "all_products",
      );

    if (initialFilterButton) {
      initialFilterButton.click();
    } else {
      filterProducts("all_products");
    }
  }
});

/**
 * -------------------------------------------------------------------------------------------
 * INUVET CUSTOM NEWSLETTER (Marketing Cloud integration)
 * -------------------------------------------------------------------------------------------
 */

document.addEventListener("DOMContentLoaded", function () {
  const countrySelect = document.getElementById("country_code");

  const switzerlandLanguageGroup = document.getElementById(
    "switzerland-language-group",
  );
  const switzerlandLanguageSelect = document.getElementById("00NS7000002owqs");

  const belgiumLanguageGroup = document.getElementById(
    "belgium-language-group",
  );
  const belgiumLanguageSelect = document.getElementById("00NS7000002owqr");

  // Function to hide all language fields
  function hideAllLanguageFields() {
    // Hide Switzerland language field
    if (switzerlandLanguageGroup && switzerlandLanguageSelect) {
      switzerlandLanguageGroup.style.display = "none";
      switzerlandLanguageSelect.disabled = true;
      switzerlandLanguageSelect.removeAttribute("required");
    }

    // Hide Belgium language field
    if (belgiumLanguageGroup && belgiumLanguageSelect) {
      belgiumLanguageGroup.style.display = "none";
      belgiumLanguageSelect.disabled = true;
      belgiumLanguageSelect.removeAttribute("required");
    }
  }

  // Initial setup: Hide all language fields
  hideAllLanguageFields();

  // Event listener for country selection change
  if (countrySelect) {
    countrySelect.addEventListener("change", function () {
      const selectedCountry = this.value;

      // Hide all language fields initially
      hideAllLanguageFields();

      if (
        selectedCountry === "CH" &&
        switzerlandLanguageGroup &&
        switzerlandLanguageSelect
      ) {
        // Show Switzerland language field
        switzerlandLanguageGroup.style.display = "block";
        switzerlandLanguageSelect.disabled = false;
        switzerlandLanguageSelect.setAttribute("required", "required");
      } else if (
        selectedCountry === "BE" &&
        belgiumLanguageGroup &&
        belgiumLanguageSelect
      ) {
        // Show Belgium language field
        belgiumLanguageGroup.style.display = "block";
        belgiumLanguageSelect.disabled = false;
        belgiumLanguageSelect.setAttribute("required", "required");
      }
    });
  }
});

/**
 * -------------------------------------------------------------------------------------------
 * INUVET CUSTOM PROMOTION CARD
 * -------------------------------------------------------------------------------------------
 */

// Function to fetch cart data
async function fetchCartData() {
  const response = await fetch("/cart.js");
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const cartData = await response.json();
  return cartData;
}

// Using this variable to keep track of the last threshold popup (we show it only once)
let lastThresholdPopupShowed = false;

// Function to update the promotion card
function updatePromotionCard(cart) {
  // Get cart amount
  const cartAmount = cart.total_price / 100;

  // Get current money threshold
  const currentThresholdMoney = getCurrentThresholdMoney(cartAmount);

  // Get next money threshold
  let nextThresholdMoney = getNextThresholdMoney(cartAmount);

  // localStorage.setItem('naturalDiscount', true);
  localStorage.setItem("promotionCardNextThreshold", nextThresholdMoney.amount);
  localStorage.setItem(
    "promotionCardNextFreeAmount",
    nextThresholdMoney.quantity,
  );

  // Show promo money and goodies
  const promoCardTitle = document.getElementById("promotion-card-title");
  const promoCardGoodie1 = document.getElementById("promotion-card-goodie1");
  const promoCardGoodie3 = document.getElementById("promotion-card-goodie3");
  const promoCardGoodie4 = document.getElementById("promotion-card-goodie4");
  const promoCardGoodie5 = document.getElementById("promotion-card-goodie5");
  const goodie3Amount = document.getElementById("goodie3-amount");
  const goodie4Amount = document.getElementById("goodie4-amount");
  const goodie5Amount = document.getElementById("goodie5-amount");
  const goodie3LabelSingular = document.getElementById(
    "goodie3-amount-label-singular",
  );
  const goodie4LabelSingular = document.getElementById(
    "goodie4-amount-label-singular",
  );
  const goodie5LabelSingular = document.getElementById(
    "goodie5-amount-label-singular",
  );

  if (
    promoCardTitle &&
    promoCardGoodie1 &&
    promoCardGoodie3 &&
    promoCardGoodie4 &&
    promoCardGoodie5 &&
    cartAmount < 300
  ) {
    promoCardTitle.removeAttribute("hidden", "");
    promoCardGoodie1.removeAttribute("hidden", "");
    promoCardGoodie3.setAttribute("hidden", "");
    promoCardGoodie4.setAttribute("hidden", "");
    promoCardGoodie5.setAttribute("hidden", "");
  } else if (
    promoCardTitle &&
    promoCardGoodie1 &&
    promoCardGoodie3 &&
    promoCardGoodie4 &&
    promoCardGoodie5 &&
    cartAmount < 2000
  ) {
    promoCardTitle.removeAttribute("hidden", "");
    promoCardGoodie1.removeAttribute("hidden", "");
    promoCardGoodie3.removeAttribute("hidden", "");
    promoCardGoodie4.setAttribute("hidden", "");
    promoCardGoodie5.setAttribute("hidden", "");
    goodie3Amount.textContent = `${nextThresholdMoney.goodie3}`;
    goodie3LabelSingular.removeAttribute("hidden", "");
  } else if (
    promoCardTitle &&
    promoCardGoodie1 &&
    promoCardGoodie3 &&
    promoCardGoodie4 &&
    promoCardGoodie5 &&
    cartAmount < 7500
  ) {
    promoCardTitle.removeAttribute("hidden", "");
    promoCardGoodie1.removeAttribute("hidden", "");
    promoCardGoodie3.setAttribute("hidden", "");
    promoCardGoodie4.removeAttribute("hidden", "");
    promoCardGoodie5.setAttribute("hidden", "");
    goodie4Amount.textContent = `${nextThresholdMoney.goodie4}`;
    goodie4LabelSingular.removeAttribute("hidden", "");
  } else if (
    promoCardTitle &&
    promoCardGoodie1 &&
    promoCardGoodie3 &&
    promoCardGoodie4 &&
    promoCardGoodie5 &&
    cartAmount >= 7500
  ) {
    promoCardTitle.removeAttribute("hidden", "");
    promoCardGoodie1.removeAttribute("hidden", "");
    promoCardGoodie3.setAttribute("hidden", "");
    promoCardGoodie4.setAttribute("hidden", "");
    promoCardGoodie5.removeAttribute("hidden", "");
    goodie5Amount.textContent = `${nextThresholdMoney.goodie5}`;
    goodie5LabelSingular.removeAttribute("hidden", "");
  }

  let storedNextThresholdMoney = Number(
    localStorage.getItem("nextThresholdMoney") || 300,
  );

  // localStorage.setItem('naturalDiscount', true);
  localStorage.setItem("promotionCardNextThreshold", nextThresholdMoney.amount);
  localStorage.setItem(
    "promotionCardNextFreeAmount",
    nextThresholdMoney.quantity,
  );

  // Update title - promotion card money
  const promotionCardMoneyTitleElement = document.getElementById(
    "promotion-card-money-right-side-title",
  );

  if (promotionCardMoneyTitleElement) {
    promotionCardMoneyTitleElement.textContent = `€${nextThresholdMoney.amount}`;
  }

  // Update offer - promotion card money
  const promotionCardMoneyOfferElement = document.getElementById(
    "promotion-card-money-right-side-offer",
  );

  if (promotionCardMoneyOfferElement) {
    promotionCardMoneyOfferElement.textContent = `€${nextThresholdMoney.quantity}`;
  }

  const naturalDiscount = window.naturalDiscount;

  // If user crossed a new threshold...
  if (
    currentThresholdMoney.amount >= storedNextThresholdMoney &&
    naturalDiscount
  ) {
    // Do not show anything if final threshold already globally marked
    if (isFinalThresholdReached()) {
      // still update next threshold and persist it, but don't show overlay
      nextThresholdMoney = getNextThresholdMoney(cartAmount);
      localStorage.setItem("nextThresholdMoney", nextThresholdMoney.amount);
      return;
    }

    // Only show overlay if we haven't shown it for THIS threshold amount yet
    if (!hasShownOverlayForThreshold(currentThresholdMoney.amount)) {
      // show overlay
      // showPromotionOverlay(currentThresholdMoney, cartAmount);

      // record that we showed for this threshold so it won't show again for same threshold
      markOverlayShownForThreshold(currentThresholdMoney.amount);
    }

    // If this is the last threshold (>= 750) mark final reached so it never shows again
    if (currentThresholdMoney.amount >= 750) {
      markFinalThresholdReached();
    }

    // Save the new nextThreshold to localStorage (same behavior as before)
    nextThresholdMoney = getNextThresholdMoney(cartAmount);
    if (
      nextThresholdMoney &&
      typeof nextThresholdMoney.amount !== "undefined"
    ) {
      localStorage.setItem("nextThresholdMoney", nextThresholdMoney.amount);
    }
  }

  updatePromoCardImage(cartAmount);
}

// Function to calculate free products based on cart amount
function calculateFreeProducts(cartAmount) {
  let quantity = 0;
  for (const threshold of discountThresholds) {
    if (cartAmount >= threshold.amount && threshold.quantity > quantity) {
      quantity = threshold.quantity;
    }
  }
  return quantity;
}

// Function to get the next threshold
function getNextThreshold(cartAmount) {
  // Sort thresholds in ascending order
  const sortedThresholds = discountThresholds
    .slice()
    .sort((a, b) => a.amount - b.amount);

  for (const threshold of sortedThresholds) {
    if (cartAmount < threshold.amount) {
      return threshold;
    }
  }
  return sortedThresholds[sortedThresholds.length - 1];
}

// Function to get the next money threshold
function getNextThresholdMoney(cartAmount) {
  // Sort thresholds in ascending order
  const sortedThresholdsMoney = discountThresholdsMoney
    .slice()
    .sort((a, b) => a.amount - b.amount);

  for (const threshold of sortedThresholdsMoney) {
    if (cartAmount < threshold.amount) {
      return threshold;
    }
  }
  return sortedThresholdsMoney[sortedThresholdsMoney.length - 1];
}

// Function to get the current threshold
function getCurrentThreshold(cartAmount) {
  // Sort thresholds in ascending order
  const sortedThresholds = discountThresholds
    .slice()
    .sort((a, b) => b.amount - a.amount);

  for (const threshold of sortedThresholds) {
    if (cartAmount >= threshold.amount) {
      return threshold;
    }
  }
  return { amount: 0, quantity: 0, colorClass: "orange" };
}

// Function to get the current money threshold
function getCurrentThresholdMoney(cartAmount) {
  if (!discountThresholdsMoney) return;
  // Sort thresholds in ascending order
  const sortedThresholdsMoney = discountThresholdsMoney
    .slice()
    .sort((a, b) => b.amount - a.amount);

  for (const threshold of sortedThresholdsMoney) {
    if (cartAmount >= threshold.amount) {
      return threshold;
    }
  }
  return { amount: 0, quantity: 0 };
}

// Function to show promotion overlay
function showPromotionOverlay(currentThreshold, cartAmount) {
  const overlay = document.getElementById("promotion-overlay-container");
  if (!overlay) return;

  const overlayOfferElementMoney = document.getElementById(
    "promotion-overlay-right-side-offer-money",
  );
  const overlayOfferElementRiegel = document.getElementById(
    "promotion-overlay-right-side-offer-goodie1",
  );
  const overlayOfferElementGoodie3Container = document.getElementById(
    "promotion-overlay-right-side-offer-goodie3-container",
  );
  const overlayOfferElementGoodie3 = document.getElementById(
    "promotion-overlay-right-side-offer-goodie3",
  );
  const goodie3AmountOverlay = document.getElementById(
    "overlay-goodie-3-amount",
  );
  const goodie3LabelSingularOverlay = document.getElementById(
    "overlay-goodie-3-amount-label-singular",
  );
  const goodie3LabelPluralOverlay = document.getElementById(
    "overlay-goodie-3-amount-label-plural",
  );

  if (overlayOfferElementMoney) {
    overlayOfferElementMoney.textContent = `€${currentThreshold.quantity}.`;
  }

  if (overlayOfferElementRiegel && cartAmount >= 300) {
    overlayOfferElementRiegel.removeAttribute("hidden", "");
  }

  if (
    overlayOfferElementGoodie3 &&
    goodie3AmountOverlay &&
    goodie3LabelSingularOverlay &&
    goodie3LabelPluralOverlay &&
    cartAmount < 300
  ) {
    overlayOfferElementGoodie3Container.setAttribute("hidden", "");
    overlayOfferElementGoodie3.setAttribute("hidden", "");
    goodie3LabelSingularOverlay.setAttribute("hidden", "");
    goodie3LabelPluralOverlay.setAttribute("hidden", "");
  } else if (
    overlayOfferElementGoodie3 &&
    goodie3AmountOverlay &&
    goodie3LabelSingularOverlay &&
    goodie3LabelPluralOverlay &&
    cartAmount >= 300
  ) {
    overlayOfferElementGoodie3Container.removeAttribute("hidden", "");
    overlayOfferElementGoodie3.removeAttribute("hidden", "");
    goodie3AmountOverlay.textContent = `${currentThreshold.goodie3}`;
    goodie3LabelSingularOverlay.removeAttribute("hidden", "");
    goodie3LabelPluralOverlay.setAttribute("hidden", "");
  }
  // Display the overlay
  overlay.classList.add("promotion-overlay__active");
  overlay.setAttribute("aria-hidden", "false");
}

// Function to hide promotion overlay
function hidePromotionOverlay() {
  const overlay = document.getElementById("promotion-overlay-container");

  if (!overlay) return;

  overlay.classList.remove("promotion-overlay__active");
  overlay.setAttribute("aria-hidden", "true");
}

// Persistent state helpers
function markOverlayShownForThreshold(amount) {
  if (!amount && amount !== 0) return;
  try {
    localStorage.setItem(`promotionOverlayShown_${amount}`, "1");
  } catch (e) {
    /* ignore storage errors */
  }
}

function hasShownOverlayForThreshold(amount) {
  try {
    return !!localStorage.getItem(`promotionOverlayShown_${amount}`);
  } catch (e) {
    return false;
  }
}

function markFinalThresholdReached() {
  try {
    localStorage.setItem("promotionOverlayFinalReached", "1");
  } catch (e) {}
}

function isFinalThresholdReached() {
  try {
    return !!localStorage.getItem("promotionOverlayFinalReached");
  } catch (e) {
    return false;
  }
}

// Function to update the promo card image - 2026 q1
function updatePromoCardImage(cartAmount) {
  const promoCardImageElement = document.getElementById("promotion-card-image");
  if (!promoCardImageElement) return;

  if (cartAmount < 300) {
    promoCardImageElement.src =
      "https://cdn.shopify.com/s/files/1/0827/3648/0599/files/sweets_icon_560.png?v=1747687845";
  } else if (cartAmount >= 300 && cartAmount < 2000) {
    promoCardImageElement.src =
      "https://inuvet.com/cdn/shop/files/icon_schreibtischauflage_1200x1200.png";
  } else if (cartAmount >= 2000 && cartAmount < 7500) {
    promoCardImageElement.src =
      "https://cdn.shopify.com/s/files/1/0827/3648/0599/files/2026_02_18_inuvet_website_produktbild_opetasche_alpha.png?v=1772183439";
  } else if (cartAmount >= 7500) {
    promoCardImageElement.src =
      "https://cdn.shopify.com/s/files/1/0827/3648/0599/files/G-011.28.388-HEINE-BETA200-LED-VET-otoscope-2_1920x1920_c18b85af-79e1-4151-93dd-342c725780e5.png?v=1767294149";
  }
}

// Function for processing cart updates
function processCartUpdate() {
  setTimeout(async () => {
    try {
      const cart = await fetchCartData();
      updatePromotionCard(cart);
    } catch (error) {
      console.error("Error updating promotion card after cart change:", error);
    }
  }, 1000);
}

// Listen for cart updates (add to cart button clicks)
document.body.addEventListener("click", (event) => {
  if (
    event.target.closest(".product-form__add-button") ||
    event.target.closest(".quantity-selector__button") ||
    event.target.closest(".line-item__remove-button") ||
    event.target.closest(".drawer__content") ||
    event.target.closest(".card-button__logged-in")
  ) {
    processCartUpdate();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  //Run card update
  processCartUpdate();

  const storedNextThresholdMoney = localStorage.getItem(
    "promotionCardNextThreshold",
  );
  const storedNextFreeAmount = localStorage.getItem(
    "promotionCardNextFreeAmount",
  );

  if (storedNextThresholdMoney && storedNextFreeAmount) {
    // Use them in your in-memory variables
    const nextThreshold = Number(storedNextThresholdMoney);
    const freeAmount = Number(storedNextFreeAmount);

    // Update title - promotion card money
    const promotionCardMoneyTitleElement = document.getElementById(
      "promotion-card-money-right-side-title",
    );

    if (promotionCardMoneyTitleElement) {
      promotionCardMoneyTitleElement.textContent = `€${nextThreshold}`;
    }
    // Update offer - promotion card money
    const promotionCardMoneyOfferElement = document.getElementById(
      "promotion-card-money-right-side-offer",
    );

    if (promotionCardMoneyOfferElement) {
      promotionCardMoneyOfferElement.textContent = `€${freeAmount}`;
    }
  }

  // const overlay = document.getElementById('promotion-overlay-container');
  // if (!overlay) return;

  // const closeButton = overlay.querySelector('.promotion-overlay--close-button');

  // if (closeButton) {
  //   closeButton.addEventListener('click', (e) => {
  //     hidePromotionOverlay();

  //     e.stopPropagation();
  //     e.preventDefault();
  //   });
  // }

  // // Stop clicks inside overlay content from bubbling.
  // const content = overlay.querySelector('.promotion-overlay__content');
  // if (content) {
  //   content.addEventListener('click', (e) => e.stopPropagation());
  // }

  const stopIt = (event) => {
    const { target } = event;
    // Make sure target is an Element (not a text node, document, etc.)
    if (target instanceof Element) {
      if (target.matches(".promotion-overlay--close-button")) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    }
  };

  document.addEventListener(
    "pointerdown",
    (event) => {
      hidePromotionOverlay();
      stopIt(event);
    },
    true,
  );

  document.addEventListener("click", stopIt, true);
  document.addEventListener("mousedown", stopIt, true);
  document.addEventListener("mousemove", stopIt, true);
  document.addEventListener("mouseover", stopIt, true);
  document.addEventListener("mouseup", stopIt, true);
  document.addEventListener("touchend", stopIt, true);
  document.addEventListener("touchstart", stopIt, true);
  document.addEventListener("pointerover", stopIt, true);
  document.addEventListener("pointerenter", stopIt, true);
  document.addEventListener("pointermove", stopIt, true);
  document.addEventListener("pointerup", stopIt, true);
  document.addEventListener("pointerout", stopIt, true);
  document.addEventListener("pointerleave", stopIt, true);
  document.addEventListener("gotpointercapture", stopIt, true);
  document.addEventListener("lostpointercapture", stopIt, true);
});

/**
 * -------------------------------------------------------------------------------------------
 * INUVET CUSTOM PROMOTION CARD AUTO
 * -------------------------------------------------------------------------------------------
 */

async function fetchCartDataPromotionCardAuto() {
  const response = await fetch("/cart.js");
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
}

function getPromotionCardGoodiesAutoConfig() {
  const configElement = document.getElementById(
    "promotion-card-goodies-auto-config",
  );
  if (!configElement) return null;

  try {
    return JSON.parse(configElement.textContent || "{}");
  } catch (error) {
    console.error("Invalid promotion card auto config:", error);
    return null;
  }
}

function getPromotionCardGoodiesAutoThresholds(goodies) {
  const thresholdSet = new Set();

  goodies.forEach((goodie) => {
    (goodie.thresholds || []).forEach((threshold) => {
      const amount = Number(threshold.amount);
      const quantity = Number(threshold.quantity);

      if (amount > 0 && quantity > 0) {
        thresholdSet.add(amount);
      }
    });
  });

  return Array.from(thresholdSet).sort((a, b) => a - b);
}

function getNextPromotionCardGoodiesAutoThreshold(cartAmount, goodies) {
  const thresholds = getPromotionCardGoodiesAutoThresholds(goodies);
  if (!thresholds.length) return null;

  return thresholds.find((threshold) => cartAmount < threshold) || thresholds[thresholds.length - 1];
}

function getPromotionCardGoodiesAutoThresholdForGoodie(goodie, nextThreshold) {
  const thresholds = (goodie.thresholds || [])
    .map((threshold) => ({
      amount: Number(threshold.amount),
      quantity: Number(threshold.quantity),
    }))
    .filter((threshold) => threshold.amount > 0 && threshold.quantity > 0)
    .sort((a, b) => b.amount - a.amount);

  if (goodie.mode === "simple") {
    return thresholds.find((threshold) => threshold.amount <= nextThreshold);
  }

  return thresholds.find((threshold) => threshold.amount === nextThreshold);
}

function getPromotionCardGoodiesAutoOffers(config, nextThreshold) {
  return (config.goodies || [])
    .map((goodie) => {
      const threshold = getPromotionCardGoodiesAutoThresholdForGoodie(
        goodie,
        nextThreshold,
      );

      if (!threshold) return null;

      const quantity = Number(threshold.quantity) || 1;
      const label =
        goodie.mode === "simple"
          ? goodie.cardLabel || goodie.singularLabel || `Goodie ${goodie.index}`
          : quantity === 1
            ? goodie.singularLabel || `Goodie ${goodie.index}`
            : goodie.pluralLabel || goodie.singularLabel || `Goodie ${goodie.index}`;

      return {
        amount: threshold.amount,
        image: goodie.image || "",
        index: Number(goodie.index),
        label,
        mode: goodie.mode,
        quantity,
      };
    })
    .filter(Boolean)
    .sort((a, b) => {
      if (a.mode === b.mode) return a.index - b.index;
      return a.mode === "simple" ? -1 : 1;
    });
}

function getPromotionCardGoodiesAutoImage(offers) {
  const exactSteppedOffer = offers.find(
    (offer) => offer.mode !== "simple" && offer.image,
  );
  if (exactSteppedOffer) return exactSteppedOffer.image;

  const offerWithImage = offers.find((offer) => offer.image);
  return offerWithImage ? offerWithImage.image : "";
}

function updatePromotionCardGoodiesAuto(cart) {
  const config = getPromotionCardGoodiesAutoConfig();
  const container = document.getElementById("promotion-card-money-container-auto");
  const titleAmount = document.getElementById(
    "promotion-card-money-right-side-title-auto",
  );
  const image = document.getElementById("promotion-card-image-auto");
  const list = document.getElementById("promotion-card-goodies-list-auto");

  if (!config || !container || !titleAmount || !image || !list) return;

  const goodies = config.goodies || [];
  const cartAmount = cart.total_price / 100;
  const nextThreshold = getNextPromotionCardGoodiesAutoThreshold(
    cartAmount,
    goodies,
  );

  if (!nextThreshold) {
    container.setAttribute("hidden", "");
    return;
  }

  const offers = getPromotionCardGoodiesAutoOffers(config, nextThreshold);

  if (!offers.length) {
    container.setAttribute("hidden", "");
    return;
  }

  titleAmount.textContent = `€${nextThreshold}`;
  list.innerHTML = "";

  offers.forEach((offer) => {
    const item = document.createElement("li");
    item.className = "promotion-card-goodie-auto";
    item.textContent =
      offer.mode === "simple" ? offer.label : `${offer.quantity} x ${offer.label}`;
    list.appendChild(item);
  });

  const imageUrl = getPromotionCardGoodiesAutoImage(offers);
  if (imageUrl) {
    image.src = imageUrl;
    image.alt = offers.find((offer) => offer.image === imageUrl)?.label || "";
  } else {
    image.removeAttribute("src");
    image.alt = "";
  }

  localStorage.setItem("promotionCardNextThresholdAuto", nextThreshold);
  container.removeAttribute("hidden");
}

function processPromotionCardGoodiesAutoUpdate() {
  if (!document.getElementById("promotion-card-money-container-auto")) return;

  setTimeout(async () => {
    try {
      const cart = await fetchCartDataPromotionCardAuto();
      updatePromotionCardGoodiesAuto(cart);
    } catch (error) {
      console.error("Error updating auto promotion card after cart change:", error);
    }
  }, 1000);
}

document.body.addEventListener("click", (event) => {
  if (
    event.target.closest(".product-form__add-button") ||
    event.target.closest(".quantity-selector__button") ||
    event.target.closest(".line-item__remove-button") ||
    event.target.closest(".drawer__content") ||
    event.target.closest(".card-button__logged-in")
  ) {
    processPromotionCardGoodiesAutoUpdate();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  processPromotionCardGoodiesAutoUpdate();
});

/**
 * -------------------------------------------------------------------------------------------
 * HIDING CBD PRODUCTS REVIEWS
 * -------------------------------------------------------------------------------------------
 */

document.addEventListener("DOMContentLoaded", function () {
  if (
    window.location.pathname.includes("calmin") ||
    window.location.pathname.includes("travel") ||
    window.location.pathname.includes("lindiol")
  ) {
    const observer = new MutationObserver((mutations, obs) => {
      const reviewWidget = document.querySelector(".shopify-section--apps");
      const reviewSnippet = document.querySelector(".shopify-app-block");

      if (reviewWidget && reviewSnippet) {
        reviewWidget.style.display = "none";
        reviewSnippet.style.display = "none";
        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
});

/**
 * -------------------------------------------------------------------------------------------
 * JSON ANIMATIONS
 * -------------------------------------------------------------------------------------------
 */

document.addEventListener("DOMContentLoaded", function () {
  var animationContainers = document.querySelectorAll(".animation-container");
  var animationContainersImageWithText = document.querySelectorAll(
    ".ed-image-with-text--animation-container",
  );
  var animationContainersImageWithTextEmbed = document.querySelectorAll(
    ".image-with-text-embed--animation-container",
  );
  var animationContainersSearchPage = document.querySelectorAll(
    ".main-search-visual-header__animation",
  );
  var animationContainersMobile = document.querySelectorAll(
    ".animation-container-mobile",
  );
  var animationContainersMobileImageWithText = document.querySelectorAll(
    ".ed-image-with-text--animation-container-mobile",
  );

  function loadJsonAnimations(containers) {
    containers.forEach(function (container) {
      var jsonUrl = container.getAttribute("data-json-url");

      if (!jsonUrl || container.dataset.lottieInitialized === "true") {
        return;
      }

      lottie.loadAnimation({
        container: container,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: jsonUrl,
      });

      container.dataset.lottieInitialized = "true";
    });
  }

  loadJsonAnimations(animationContainers);
  loadJsonAnimations(animationContainersImageWithText);
  loadJsonAnimations(animationContainersImageWithTextEmbed);
  loadJsonAnimations(animationContainersSearchPage);
  loadJsonAnimations(animationContainersMobile);
  loadJsonAnimations(animationContainersMobileImageWithText);

  const parentAnimationEls = document.querySelectorAll(
    ".slideshow__slide-inner",
  );
  parentAnimationEls.forEach((parentAnimationEl) => {
    const childAnimationEl = parentAnimationEl.querySelector(
      ".animation-container-mobile",
    );
    if (childAnimationEl) {
      parentAnimationEl.classList.add("json-animation-mobile");
    }
  });
});

/**
 * -------------------------------------------------------------------------------------------
 * AI-GENERATED IMAGE LABELS
 * -------------------------------------------------------------------------------------------
 */

document.addEventListener("DOMContentLoaded", function () {
  const aiImageSelector = 'img[alt^="KI_"], img[alt^="KI-"]';

  const addAiGeneratedLabel = (image) => {
    if (image.dataset.aiGeneratedLabelled === "true") {
      return;
    }

    const mediaElement =
      image.parentElement?.tagName === "PICTURE" ? image.parentElement : image;
    const imageWrapper = mediaElement.parentElement;

    if (!imageWrapper) {
      return;
    }

    if (window.getComputedStyle(imageWrapper).position === "static") {
      imageWrapper.classList.add("ai-generated-image-wrapper--positioned");
    }

    const label = document.createElement("span");
    label.className = "ai-generated-image-label";
    label.textContent = "A.I. generated";
    label.setAttribute("aria-hidden", "true");

    image.classList.forEach((className) => {
      if (className.startsWith("hidden-")) {
        label.classList.add(className);
      }
    });

    mediaElement.insertAdjacentElement("afterend", label);
    image.dataset.aiGeneratedLabelled = "true";
  };

  const labelAiGeneratedImages = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root !== document) {
      return;
    }

    if (root.matches?.(aiImageSelector)) {
      addAiGeneratedLabel(root);
    }

    root.querySelectorAll?.(aiImageSelector).forEach(addAiGeneratedLabel);
  };

  labelAiGeneratedImages(document);

  const aiImageObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(labelAiGeneratedImages);
    });
  });

  aiImageObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

/**
 * -------------------------------------------------------------------------------------------
 * ITALIAN OVERLAY FUNCTIONALITY
 * -------------------------------------------------------------------------------------------
 */

// Italian overlay functionality
(function () {
  "use strict";

  // Cookie management functions
  const getCookie = (name) => {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)"),
    );
    return match ? decodeURIComponent(match[2]) : null;
  };

  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
  };

  // Check if user should see the overlay
  const shouldShowItalianOverlay = () => {
    // Check if user has already dismissed the overlay (cookie exists)
    const dismissedCookie = getCookie("italian_overlay_dismissed");
    if (dismissedCookie) {
      return false;
    }

    // Check if user is from Italy (this will be set by the server-side logic)
    return window.showItalianOverlay === true;
  };

  // Show the overlay
  const showItalianOverlay = () => {
    const overlay = document.getElementById("italian-overlay");
    if (overlay) {
      overlay.style.display = "flex";
      startCountdown();
    }
  };

  // Hide the overlay
  const hideItalianOverlay = () => {
    const overlay = document.getElementById("italian-overlay");
    if (overlay) {
      overlay.style.display = "none";
    }
  };

  // Countdown functionality
  let countdownInterval;
  const startCountdown = () => {
    let timeLeft = 10;
    const countdownElement = document.getElementById("countdown-timer");

    if (countdownElement) {
      countdownElement.textContent = timeLeft;
    }

    countdownInterval = setInterval(() => {
      timeLeft--;

      if (countdownElement) {
        countdownElement.textContent = timeLeft;
      }

      if (timeLeft <= 0) {
        clearInterval(countdownInterval);
        redirectToVetalita();
      }
    }, 1000);
  };

  // Redirect to Vetalità
  const redirectToVetalita = () => {
    // Check if we're on a product page and preserve the path
    const currentPath = window.location.pathname;
    let targetUrl = "https://vetalita.it";

    // If we're on a product page, append the same path
    if (currentPath.includes("/products/")) {
      targetUrl += currentPath;
    }

    window.location.href = targetUrl;
  };

  // Event listeners
  const setupEventListeners = () => {
    const goToVetalitaBtn = document.getElementById("go-to-vetalita");
    const stayOnInuvetBtn = document.getElementById("stay-on-inuvet");

    if (goToVetalitaBtn) {
      goToVetalitaBtn.addEventListener("click", () => {
        clearInterval(countdownInterval);
        redirectToVetalita();
      });
    }

    if (stayOnInuvetBtn) {
      stayOnInuvetBtn.addEventListener("click", () => {
        clearInterval(countdownInterval);
        hideItalianOverlay();
        // Set cookie to dismiss overlay for 3 days
        setCookie("italian_overlay_dismissed", "true", 3);
      });
    }
  };

  // Initialize overlay when DOM is ready
  const initItalianOverlay = () => {
    if (shouldShowItalianOverlay()) {
      setupEventListeners();
      showItalianOverlay();
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initItalianOverlay);
  } else {
    initItalianOverlay();
  }
})();
